// extracted by mini-css-extract-plugin
export default {"container":"Ak-z","blurb":"Bk-z","links":"Ck-z"};